import { ChangeDetectorRef, Component, inject, Inject, OnInit } from '@angular/core';
import {  Carousel  } from 'primeng/carousel';
import { CommonModule } from '@angular/common'; 
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { DataViewModule } from 'primeng/dataview';
import { OrderListModule } from 'primeng/orderlist';
import { PickListModule } from 'primeng/picklist';
import { SelectButtonModule } from 'primeng/selectbutton';
import { TagModule } from 'primeng/tag';
import { ApplicationInsightsService } from '../../../domain/applicationinsights-displayer'; 
import { ActivatedRoute } from '@angular/router';
import IDisplayCards from '../../../domain/ports/display/i-display-cards';
import { Card } from '../../../domain/models/card';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { TranslateService } from '@ngx-translate/core';
import {  UserRolesService } from '../../../service/user-roles.service';
import { LoadingService } from '../../../service/loading.service';
import { combineLatest, take } from 'rxjs';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { ConfirmDialog } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';
import { ConfirmationService, MessageService } from 'primeng/api';
import { TranslateModule } from '@ngx-translate/core'; 
import IDisplayTiam from '../../../domain/ports/display/i-display-tiam';

@Component({
  selector: 'app-test',
  imports: [Carousel, CommonModule, DataViewModule, SelectButtonModule, FormsModule, PickListModule, OrderListModule, TagModule, ButtonModule, ProgressSpinnerModule, ConfirmDialog, ButtonModule, ToastModule, TranslateModule ],
  templateUrl: './cards.component.html',
  styleUrl: './cards.component.scss' ,
  providers: [ConfirmationService, MessageService]
})
export class CardsComponent implements OnInit {
  currentLang: string = 'en';
  pageIndex = 0;
  pageSize = 1000;
  items: Card[] = [];
  totalRecords : number = 0;
  loading: boolean = false;
  numVisible: number = 4;
  carouselClass = 'normal-carousel';
  userRoles: string[] = [];
  visible: boolean = false;
  showCarousel: boolean = false;

  responsiveOptions: any[] | undefined;
  private readonly oidcSecurityService = inject(OidcSecurityService);

  constructor(
    @Inject('IDisplayCards') private cardsDisplayer: IDisplayCards,
    @Inject('IDisplayTiam') private tiamDisplayer: IDisplayTiam,
    private route: ActivatedRoute, private translate: TranslateService,
    private userRolesService: UserRolesService,
    private loadingService: LoadingService,
    private cdr: ChangeDetectorRef,
    private confirmationService: ConfirmationService, 
    private messageService: MessageService
  ) {
    this.userRolesService.roles$.subscribe(roles => {
      this.userRoles = roles.map(r => r.role);
    });
  }

  ngOnInit() {
    this.currentLang = this.translate.currentLang || this.translate.getDefaultLang();

    this.translate.onLangChange.subscribe(lang => {
      this.currentLang = lang.lang;
    });

    // Si el usuario está autenticado, espera roles; si no, llama a getCards directamente
    this.oidcSecurityService.checkAuth().pipe(take(1)).subscribe(({ isAuthenticated }) => {
      if (isAuthenticated) {
        combineLatest([
          this.userRolesService.roles$,
          this.route.params
        ])
        .subscribe(([roles, params]) => {
          this.userRoles = roles.map(r => r.role);
          const id = params['id'];
          if (id /*&& roles && roles.length > 0*/) {
            this.getCards(id);
          }
        });
      } else {
        this.route.params.subscribe(params => {
          const id = params['id'];
          if (id) {
            this.getCards(id);
          }
        });
      }
    });
  }

   getCards(id: number) {
      this.loadingService.setLoading(true);
      this.showCarousel = false; 
      this.cdr.detectChanges();  

      this.cardsDisplayer.getCardByModuleId(id).subscribe(response => {
        if (response.status?.success) {
          this.items = [];
          this.cdr.detectChanges();

          this.items = [...response.data];
          this.items.forEach(card => {
            card.appsCards.forEach(app => {
              app.hasAccess = this.hasAccess(app.role) || app.isLinkAdded; 
            });
          });

          const itemCount = this.items.length;
          this.numVisible = Math.min(4, itemCount);
          this.carouselClass = this.items.length < 4 ? 'few-items-carousel' : 'normal-carousel';

          this.responsiveOptions = [
            { breakpoint: '1400px', numVisible: Math.min(4, itemCount), numScroll: 1 },
            { breakpoint: '1300px', numVisible: Math.min(3, itemCount), numScroll: 1 },
            { breakpoint: '1100px', numVisible: Math.min(2, itemCount), numScroll: 1 },
            { breakpoint: '850px',  numVisible: Math.min(1, itemCount), numScroll: 1 }
          ];

          this.cdr.detectChanges();

          this.showCarousel = true; 
          this.cdr.detectChanges();
        }

        this.loadingService.setLoading(false);
      }, error => {
        this.loadingService.setLoading(false);
      });
  }

  hasAccess(requiredRole: string): boolean {
    if (!requiredRole) return false;

    const normalizedRoles = this.userRoles.map(r => r.toLowerCase());
    const normalizedRequired = requiredRole.toLowerCase();
    const result = normalizedRoles.includes(normalizedRequired);

    return result;
  }


  handleAppClick(app: { url: string; name: string; hasAccess: boolean; role: string; description_en: string, description_sp: string, isLinkAdded : boolean}): void {
    if(app.isLinkAdded) {
      this.openUrl(app.url);
      return;
    }    
   
        this.oidcSecurityService.checkAuth().pipe(take(1)).subscribe(({ isAuthenticated }) => {
      if (!isAuthenticated) {
        /*this.oidcSecurityService.authorize();
        return;*/
        this.openUrl(app.url);
      }
      if (app.hasAccess) {
        this.openUrl(app.url);
      } else {
        this.showDialog(app);
      }
    });
      
  }


  showDialog(app: any): void {
      this.checkStatusRole(app);
  }

  openUrl(url: string): void {
    const fullUrl = url.startsWith('http') ? url : `https://${url}`;
    window.open(fullUrl, '_blank');
  }

  checkStatusRole(app: any): void {
    this.loadingService.setLoading(true);
    this.tiamDisplayer.GetStatusRole(app.name).subscribe({
      next: (response) => {
        this.loadingService.setLoading(false);
        if (response.data === 'Started') {
          this.showOngoingDialog(app);
        } else {
          this.requestAccess(app);
        }
      },
      error: (err) => {
        this.loadingService.setLoading(false);
       this.messageService.add({ severity: 'error', summary: this.translate.instant('Error'), detail: this.translate.instant('ApplicationNotAccessError') });
      }
    });
  }

  requestAccess(app: any) {
        this.confirmationService.confirm({
            header: this.translate.instant('ApplicationNotAccessTitle'),
            message: 
                this.currentLang === 'es'
                  ? (app.description_sp ? app.description_sp + '\n' + '\n' + this.translate.instant('ApplicationNotAccessDesc') : this.translate.instant('ApplicationNotAccessDesc'))
                  : (app.description_en ? app.description_en + '\n' + '\n' + this.translate.instant('ApplicationNotAccessDesc')  : this.translate.instant('ApplicationNotAccessDesc')),
            closable: true,
            closeOnEscape: true,
            dismissableMask: true,
            accept: () => {
              this.loadingService.setLoading(true);
                this.tiamDisplayer.RequestNewRole(app.role).subscribe({
                    next: (response) => {
                      this.loadingService.setLoading(false);
                        if (response.data) {
                            this.messageService.add({ severity: 'success', summary: this.translate.instant('succesfully'), detail: this.translate.instant('ApplicationNotAccessSuccess') });
                        } else {
                            this.messageService.add({ severity: 'error', summary: this.translate.instant('Error'), detail: this.translate.instant('ApplicationNotAccessError') });
                        }
                    },
                    error: (err) => {
                      this.loadingService.setLoading(false);
                        this.messageService.add({ severity: 'error', summary: this.translate.instant('Error'), detail: this.translate.instant('ApplicationNotAccessError') });
                    }
                });
                //this.messageService.add({ severity: 'success', summary: this.translate.instant('succesfully'), detail: this.translate.instant('ApplicationNotAccessSuccess') });
            },
        });
    }

  showOngoingDialog(app: any): void {
    this.confirmationService.confirm({
      key: 'ongoing',
      closable: true,
      closeOnEscape: true,
      dismissableMask: true,
      acceptLabel: this.translate.instant('ApplicationAccessPendingButton'),
      rejectVisible: false,
      accept: () => {
      }
    });
  }

}